import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { FaStar, FaBookmark } from 'react-icons/fa';
import { AuthContext } from '../../utils/AuthContext';
import { hostNameBack } from '../../utils/constants';
import Loader from '../../utils/Loader';

function Bookmarks() {
    const { isLogin } = useContext(AuthContext);
    const [sellers, setSellers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);

    useEffect(() => {
        if (!isLogin) {
            enqueueSnackbar("You need to log in to view bookmarks", { variant: "warning" });
            return;
        }
        const fetchBookmarks = async () => {
            try {
                const response = await axios.get(`${hostNameBack}/api/v1/bookmarks`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
                if (response.data.success) {
                    setSellers(response.data.sellers);
                }
            } catch (error) {
                enqueueSnackbar("Something went wrong!", { variant: "error" });
            } finally {
                setLoading(false);
            }
        };
        fetchBookmarks();
    }, [isLogin]);

    const handleRemoveBookmark = async (sellerId) => {
        try {
            setActionLoading(true);
            const token = localStorage.getItem('token');
            await axios.delete(`${hostNameBack}/api/v1/bookmarks/${sellerId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSellers(sellers.filter(seller => seller._id !== sellerId));
            enqueueSnackbar("Seller removed from bookmarks", { variant: "success" });
        } catch (error) {
            enqueueSnackbar("Something went wrong!", { variant: "error" });
        }
        finally {
            setActionLoading(false);
        }
    };

    if(loading) return <Loader type="simple" />

    console.log(sellers);

    return (
        <div className="bookmarksDiv">

            {actionLoading && <Loader type="checkmate" />}

            <h2 className="primaryHeading">My <span>Bookmarks</span></h2>
            {sellers.length === 0 ? (
                <p className="noBookmarks">You have no bookmarked sellers yet. Start exploring sellers to bookmark your favorites!</p>
            ) : (
                <div className="sellersGrid">
                    {sellers.map(seller => (
                        <div key={seller._id} className="sellerCard">
                            <img src={seller.profileImage} alt={seller.displayName} className="profileImage" />
                            <h3 className="sellerName">{seller.displayName}</h3>
                            <div className="rating">
                                <FaStar className="starIcon" />
                                <span>{seller.rating.toFixed(1)} ({seller.noOfReviews})</span>
                            </div>
                            <div className="actions">
                                <Link to={`/profile/${seller._id}`} className="primaryBtn actionBtn">Visit Profile</Link>
                                <Link to={`/chat?p=${seller.userId}`} className="secondaryBtn actionBtn">Contact</Link>
                                <button onClick={() => handleRemoveBookmark(seller._id)} className="actionBtn removeBtn">
                                    <FaBookmark /> Remove
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Bookmarks;